module.exports = __webpack_public_path__ + "static/img/jhdd.c9611b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jhdd.png
// module id = /QUV
// module chunks = 0